import React from 'react';
import { theme } from '../Theming/Theming';
import { styled } from 'linaria/react';
import TopBarUsp from '../Layout/Header/TopBar/TopBarUsp';

const ProductUspBoxWrapper = styled('div')`
  width: 100%;
  margin-top: 1rem;
  ${theme.below.lg} {
    padding-bottom: 0;
  }
  .title {
    font-weight: ${theme.weights.bold};
    margin-bottom: 1rem;
  }
  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    ${theme.above.xl} {
      justify-content: space-between;
      flex-wrap: nowrap;
    }
    li {
      display: flex !important;
      align-items: center;
      margin: 0 1rem 1rem;
      ${theme.above.xl} {
        margin: 0;
      }
      span {
      }
      img {
        max-width: 20px;
        margin-right: 5px;
      }
    }
  }
`;

const ProductUspBox = () => {
  return (
    <ProductUspBoxWrapper>
      <TopBarUsp name={'ProductPageUsp'} />
    </ProductUspBoxWrapper>
  );
};

export default ProductUspBox;
